const persianNumbers = [
    /۰/g,
    /۱/g,
    /۲/g,
    /۳/g,
    /۴/g,
    /۵/g,
    /۶/g,
    /۷/g,
    /۸/g,
    /۹/g,
];
const arabicNumbers = [
    /٠/g,
    /١/g,
    /٢/g,
    /٣/g,
    /٤/g,
    /٥/g,
    /٦/g,
    /٧/g,
    /٨/g,
    /٩/g,
];

export const toEnglishNumbers = (numbers) => {
    if (typeof numbers === "string") {
        for (let i = 0; i < 10; i++) {
            numbers = numbers
                .replace(persianNumbers[i], i)
                .replace(arabicNumbers[i], i);
        }
    }
    return numbers;
};

export const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const amountHelperText = (amount) => {
    if (amount > 0) {
        return `${numberWithCommas(amount)} تومان`;
    }
    return " ";
};

export const processPhoneNumber = (phoneNumber, isRegistring = false) => {
    let value = toEnglishNumbers(phoneNumber);

    const re0 = new RegExp("^(\\d{10})$");
    const re1 = new RegExp("^(098|0098|\\+98)(9\\d{9})$");
    const re2 = new RegExp("^98(9\\d{9})$");

    if (isRegistring && re0.test(value) && !value.startsWith("0")) {
        value = value.replace(re0, "0$1");
    }
    if (re1.test(value)) {
        value = value.replace(re1, "0$2");
    }
    if (re2.test(value)) {
        value = value.replace(re2, "0$1");
    }

    return value;
};


const suffixes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
const farsiSuffixes = ["بایت", "کیلوبایت", "مگابایت", "گیگابایت"];

function formatBytes({
  bytes,
  decimals,
  suffixes = suffixes
}) {
  if (bytes <= 0) return "0 " + suffixes[0];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return (bytes / Math.pow(1024, i)).toFixed(decimals) + " " + suffixes[i];
}

export function formatBytesFarsiTranslated({
  bytes,
  decimals
}) {
  return formatBytes({
    bytes: bytes,
    decimals: decimals,
    suffixes: farsiSuffixes
  });
}